module.exports = __webpack_public_path__ + "src/img/turnLeft.8c504497.svg";